module.exports = __webpack_public_path__ + "img/img_level_19.9fb32a0b.png";